export enum MarketplaceFitStatus {
  NO_FIT = 'no_fit',
  POTENTIAL_FIT = 'potential_fit',
  CONVERTED_TO_PROSPECT = 'converted_to_prospect',
}
